import { styled } from "@mui/material/styles";
import { Box, Button } from "@mui/material";
import { useColors } from "../../Context/ColorsContext";

function buttonType(type) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { colors } = useColors();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    if (type === 'cancel') return colors.white
    // eslint-disable-next-line react-hooks/rules-of-hooks
    if (type === 'close') return colors.white
    // eslint-disable-next-line react-hooks/rules-of-hooks
    if (type === 'delete') return colors.red
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return colors.buttonActionColor
}

export const BackButton = styled(Button)(({type}) => {
    const { colors } = useColors();
    return {
        height: 40,
        // width: '100px',
        padding: "0 20px",
        background: buttonType(type),
        color: `${type !== 'cancel' && type !== 'close' ? colors.white : colors.buttonActionColor}`,
        borderColor: colors.buttonActionColor,
        "&:hover": {
            background: buttonType(type),
            borderColor: colors.buttonActionColor,
            opacity: 0.9
        }
    }
})

export const MapBox = styled(Box)(({ theme }) => {
    return {
        position: "relative",
        height: "100%",
        [theme.breakpoints.down('md')]: {
            position: "static",
            height: "300px"
        }
    }
})